import styled from "styled-components/macro";

export const Container = styled.div`
  /* padding: 15px 25px; */
  /* padding-left: 25px; */
  justify-content: space-between;
  text-align: left;
  background: white;
  user-select: auto;
  display: flex;
  background: var(--menu-color);
  color: var(--grey-0);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;

  .templates {
    width: 230px;
    padding: 15px 0;
    overflow-y: auto;
    scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--scrollbar-track);
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--scrollbar-thumb);
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: var(--scrollbar-thumb-hover);
    }

    h2 {
      padding: 5px 20px;
      font-size: 22px;
    }

    ul {
      margin-top: 1rem;

      li {
        padding: 8px 20px;
        cursor: pointer;

        &.active {
          background: var(--menu-color-hover);
          font-weight: 600;
        }
      }
    }
  }

  .template {
    border-left: 2px solid var(--menu-color-active);
    flex-grow: 1;
    width: calc(100% - 230px);
    padding: 25px 25px 80px 25px;
    position: relative;
    overflow-y: auto;
    scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--scrollbar-track);
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--scrollbar-thumb);
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: var(--scrollbar-thumb-hover);
    }

    h3 {
      margin-bottom: 0.5rem;
    }

    p {
      margin: 1rem auto;
      line-height: 1.2rem;

      a {
        text-decoration: underline;
        white-space: nowrap;
      }
    }

    .examples p {
      font-size: 14px;
    }

    .instructions {
      textarea {
        &:focus {
          border: 1px solid var(--primary-cta);
        }
        background: var(--menu-color-fullscreen);
        color: var(--grey-0);
        width: 462px;
        margin-right: 16px;
        min-height: 189px;
        max-height: calc(100vh - 500px);
        border: 1px solid var(--grey-2);
        border-radius: 5px;
        padding: 10px;
        font-family: Inter;
        font-size: 16px;
        margin-top: 1rem;
        resize: vertical;
      }
    }

    .cta {
      // background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 1) 35px); /* Apply the fading gradient background */
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, var(--menu-color) 35px); /* Works better for dark modes */
      position: fixed;
      width: 100%;
      bottom: 0;
      padding: 35px 25px 25px 0;
    }
  }

  button,
  input[type="submit"] {
    font-size: 16px;
    background: var(--primary-cta);

    &:hover {
      background: var(--primary-cta-hover);
    }

    &:disabled {
      background: var(--grey-2) !important;
      cursor: default;
    }

    color: white;
    border: 0;
    border-radius: 25px;
    font-family: Inter;
    font-weight: 500;
    padding: 10px 40px;
    cursor: pointer;
    margin-top: 15px;
  }
`;
